import { render, staticRenderFns } from "./bimNotices.vue?vue&type=template&id=3252723b&scoped=true&"
import script from "./bimNotices.vue?vue&type=script&lang=js&"
export * from "./bimNotices.vue?vue&type=script&lang=js&"
import style0 from "./bimNotices.vue?vue&type=style&index=0&id=3252723b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3252723b",
  null
  
)

export default component.exports